"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SchoolSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SchoolSVG = function SchoolSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M30,29a1,1,0,0,1-1,1H5a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h7.47C10.28,18,9,13.45,9,12a4.83,4.83,0,0,1,4.94-5A4.76,4.76,0,0,1,16,7.48V7a2.91,2.91,0,0,1,3-3,1,1,0,0,1,0,2,.92.92,0,0,0-1,1v.48A4.76,4.76,0,0,1,20.06,7,4.83,4.83,0,0,1,25,12c0,1.45-1.28,6-3.47,8H29a1,1,0,0,1,0,2H28v2H6a1,1,0,0,0,0,2H28v2h1A1,1,0,0,1,30,29Z"
  }));
};
exports.SchoolSVG = SchoolSVG;
SchoolSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SchoolSVG);
exports.default = _default;